<!--
 * @Descripttion: 
 * @version: 打印流程提示步骤条
 * @Author: wlk
 * @Date: 2023-11-28 15:23:45
 * @LastEditors: sueRimn
 * @LastEditTime: 2023-12-21 14:06:34
-->
<template>
  <div class="step-wrapper" v-if="isShow">
    <Steps :current="0" size="small">
      <Step :title="$lang('下载打印组件')">
        <template #description>
          <p class="desc">{{ $lang('第一步：下载官方打印组件并安装') }}</p>
          <Button type="primary" :href="CN_DOWN_LINK">
            {{ $lang('下载打印组件') }}
          </Button>
        </template>
      </Step>
      <Step :title="$lang('下载打印机驱动并安装')">
        <template #description>
          <p class="desc">{{ $lang('搜索当前打印机型号下载安装或打印机说明书中找到驱动下载方式') }}</p>
        </template>
      </Step>
    </Steps>
    <CloseOutlined class="close" @click="close" />
  </div>
</template>
<script lang="ts" setup>
  import { ref } from 'vue'
  import { Button, Steps, Step } from 'ant-design-vue'
  import { CloseOutlined } from '@ant-design/icons-vue'
  import { CN_DOWN_LINK } from '@/utils/Const'
  const isShow = ref(true)
  const close = () => {
    isShow.value = !isShow.value
  }
</script>
<style lang="less" scoped>
  .step-wrapper {
    position: relative;
    .desc {
      margin-top: 6px;
      width: 100%;
    }

    :deep(.ant-steps) {
      padding: 20px;
      background: #fff;
      margin-bottom: 10px;
      border-radius: 4px;
      box-shadow: 0px 0px 10px 0px rgba(209, 213, 223, 0.2);

      .ant-steps-item-description {
        max-width: initial;
        width: 600px;
      }
    }

    .close {
      position: absolute;
      right: 10px;
      top: 10px;
    }
  }
</style>
